import { useGraphQLQuery } from '@betterment/graphql';
import { Box, Card, H2, HStack, Link, Separator, Text, VStack } from '@betterment/samba-react';

import { useCurrentEmployerId } from '~/b4b/utils/currentEmployer';
import { urlBuilder } from '~/b4b/utils/urlBuilder';
import { SupportContactType } from '~/graphql/schema';

import { EmployerSupportDocument } from '../../help/get-support-card/graphql/query.getSupportContacts.generated';

const INCLUDED_CONTACT_TYPES: Set<string> = new Set([
  SupportContactType.Advisor,
  SupportContactType.ClientSuccessManager,
  SupportContactType.ThirdPartyAdministrator,
  SupportContactType.OnboardingAgent,
]);

export const HomeSupportCard = () => {
  const employerId = useCurrentEmployerId();

  const { data, dataState } = useGraphQLQuery(EmployerSupportDocument, {
    variables: { employerId },
  });

  if (dataState !== 'complete') return null;

  const contacts = data.employer.support.contacts.filter(c => INCLUDED_CONTACT_TYPES.has(c.contactType));

  if (contacts.length === 0) return null;

  return (
    <Box css={{ order: { base: 4 } }}>
      <Card css={{ p: 'space.300' }}>
        <Card.Header>
          <HStack css={{ justifyContent: 'space-between', alignItems: 'center' }}>
            <H2 variant="title200">Support</H2>
            <Link
              href={urlBuilder.help()}
              data-track-event="ElementClicked"
              data-track-name="GetInTouch"
              data-track-flow="Home"
              data-track-module="Support"
            >
              Get in touch
            </Link>
          </HStack>
        </Card.Header>
        <Separator css={{ my: 'space.300' }} />
        <Card.Content>
          <VStack
            css={{ gap: 'space.200' }}
            data-track-event="ElementViewed"
            data-track-name="HomeSupportCard"
            data-track-flow="Home"
            data-track-module="Support"
          >
            {contacts.map(contact => (
              <VStack key={contact.contactType} css={{ gap: 'space.25' }}>
                <Text as="p" variant="text100">
                  {contact.name}
                </Text>
                <Text as="p" color="text.weak" variant="text50">
                  {contact.title}
                </Text>
              </VStack>
            ))}
          </VStack>
        </Card.Content>
      </Card>
    </Box>
  );
};
